import React, { useState } from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import SubtitlesOutlinedIcon from "@material-ui/icons/SubtitlesOutlined";
import RefreshIcon from "@material-ui/icons/Refresh";
import Audio from "../Audio";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import withMediaToken from "../../services/mediaUrl";

/**
 * Wrapper do <Audio> que adiciona botao "Transcrever" e exibe a
 * transcricao como legenda fixa abaixo do player. Cache: se a message
 * ja tem transcription, vem do banco e nao chama IA. Reprocessar
 * forca uma nova chamada.
 */
const AudioWithTranscription = ({ message }) => {
  const [transcription, setTranscription] = useState(
    message?.transcription || ""
  );
  const [loading, setLoading] = useState(false);
  const [cached, setCached] = useState(!!message?.transcription);

  const handleTranscribe = async (reprocess = false) => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `/messages/${message.id}/transcribe`,
        { reprocess }
      );
      setTranscription(data.transcription);
      setCached(data.cached);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Audio url={withMediaToken(message.mediaUrl)} />

      {!transcription && !loading && (
        <Button
          size="small"
          variant="text"
          startIcon={<SubtitlesOutlinedIcon fontSize="small" />}
          onClick={() => handleTranscribe(false)}
          style={{ alignSelf: "flex-start", textTransform: "none", padding: "2px 8px" }}
        >
          Transcrever audio
        </Button>
      )}

      {loading && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            color: "#666",
            padding: "4px 8px"
          }}
        >
          <CircularProgress size={12} /> Transcrevendo...
        </div>
      )}

      {transcription && (
        <div
          style={{
            background: "#f5f5f5",
            border: "1px solid #e0e0e0",
            borderRadius: 4,
            padding: "6px 8px",
            marginTop: 2,
            fontSize: 12,
            color: "#333",
            maxWidth: 360
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 10,
              fontWeight: 600,
              color: "#777",
              marginBottom: 2
            }}
          >
            <SubtitlesOutlinedIcon style={{ fontSize: 12 }} />
            Transcricao {cached && "(salva)"}
            <Button
              size="small"
              onClick={() => handleTranscribe(true)}
              disabled={loading}
              style={{ marginLeft: "auto", minWidth: 0, padding: 2 }}
              title="Reprocessar"
            >
              <RefreshIcon style={{ fontSize: 12 }} />
            </Button>
          </div>
          <Typography variant="body2" style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
            {transcription}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default AudioWithTranscription;
